import { DOMAIN_TYPE_CLIENT_NOTIFICATION } from '../../../consts';
export var getClientNotification = function (notificationId) {
    return function (state) {
        return state.domain[DOMAIN_TYPE_CLIENT_NOTIFICATION]
            ? state.domain[DOMAIN_TYPE_CLIENT_NOTIFICATION][notificationId]
            : null;
    };
};
